import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { routes } from 'utils/routes';
import { AppRoutingShared } from 'containers/AppRouting/AppRoutingShared';
import { SignOutPage } from 'containers/SignOutPage';
import { PartnerDashboard } from 'containers/PartnerDashboard/PartnerDashboard';

export const AppRoutingPartner = () => {
  return (
    <Switch>
      <Route path={routes.signOutPattern()}>
        <SignOutPage />
      </Route>

      <Route
        path={[routes.clientsActivePattern(), routes.clientsCancelledPattern()]}
      >
        <PartnerDashboard />
      </Route>

      <Route path={routes.registrationPartnerPattern()}>
        <Redirect to="/" />
      </Route>

      <Route path="/" exact>
        <Redirect to={routes.clientsActive()} />
      </Route>

      <Route path="/">
        <AppRoutingShared />
      </Route>
    </Switch>
  );
};
